var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v("\n\tThis is a test!\n\t"),
      _c("toggle", {
        attrs: {
          message: "test aria message",
          name: "test_name",
          id: "test_id",
          showMessage: false
        },
        model: {
          value: _vm.toggleState,
          callback: function($$v) {
            _vm.toggleState = $$v
          },
          expression: "toggleState"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }